import * as React from "react";
import "./index.css";

const ChatTextTile = ({ clientId, message, date, isUser }) => {
  return (
    <div className={`chat-text-base ${isUser ? "user" : "from"}`}>
      <span className={`chat-text ${isUser ? "user" : "from"}`}>{message}</span>
      <span className="chat-text-date">{date}</span>
    </div>
  );
};

export default ChatTextTile;
